<template>
    <div>
        <div class="chart-panel-left" v-if="!showStatus">
            <button
                    class="chart-btn"
                    :class="{active: valueYShow === 'totalPercent'}"
                    @click="changeChartType('totalPercent')"
            >%
            </button>

            <button
                    class="chart-btn"
                    :class="{active: valueYShow !== 'totalPercent'}"
                    @click="changeChartType(null)"
            >#
            </button>
        </div>
        <div class="loader" v-if="showLoader">
            <b-spinner large></b-spinner>
        </div>
        <div class="noDataInfo" v-else-if="showStatus">
            {{translate('NoData')}}
        </div>
        <div class="chart" ref="chartdiv"></div>
    </div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    // import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import moment from "moment";

    // am4core.useTheme(am4themes_animated);

    const happyColor = '#228e00'
    const sosoColor = '#ff9d00'
    const sadColor = '#b51700'
    const indexColor = '#3F405C'

    const tooltipPercentTemplate =
    `<table>
       <tr>
         <td>{name}: {valueY.totalPercent.formatNumber('#.00')}%</td>
       </tr>
       <tr>
          <td><center>{category}</center></td>
       </tr>
    </table>`
    const tooltipDecimalTemplate =
    `<table style="color: black">
       <tr>
         <td><center>{name}: {valueY}</center></td>
       </tr>
    </table>`

    export default {
        name: 'amcharts',
        data(){
            return {
                chart: null,
                valueYShow: null,
                // labelFormat: "{valueY.totalPercent.formatNumber('#.00')}%",
                labelFormat: '',
                tooltipFormat: tooltipDecimalTemplate,
                seriesName: ['happy', 'ok', 'sad'],
                showStatus: false,
                showLoader: true,
                valueIndexAxis: null,
            }
        },

        props: ['amchartsData', 'closePopover'],

        watch:{
            amchartsData() {
                if(this.chart != null && this.chart.inited) {
                    this.showLoader = true;
                    this.refreshData()
                    // this.rotateText(ev, type)
                    console.log(this.chart)
                } else {
                    this.init()
                }
            },
            closePopover(){
                if (!this.closePopover) {
                    this.showLoader = true;
                    this.chart.data = null
                }
            }
        },

        methods: {
            changeChartType(value) {
                console.log(value)
                this.labelFormat = ''
                this.tooltipFormat = value ? tooltipPercentTemplate : tooltipDecimalTemplate
                this.valueYShow = value
                for (let i = 0; i < this.chart.series.values.length - 1; i++) {
                    this.chart.series.values[i].dataFields.valueYShow = this.valueYShow;
                }
                console.log(value)
                this.chart.validateData()
            },

            refreshData() {
                this.changeColumnsOrder()
                this.chart.data = this.dataMapping()
                this.refreshValueIndexAxis()
                this.chart.validateData()
                console.log(this.chart)
                this.showLoader = false
            },

            init(){
                const widthPercent = 80

                this.chart = am4core.create(this.$refs.chartdiv, am4charts.XYChart);
                this.chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
                this.chart.numberFormatter.numberFormat = "#";
                this.chart.numberFormatter = new am4core.NumberFormatter();
                this.chart.numberFormatter.numberFormat = "#";
                this.chart.data = this.dataMapping()
                this.chart.maskBullets = false;
                this.changeColumnsOrder()

                this.chart.padding(10, 30, 10, 30);
                this.chart.legend = new am4charts.Legend();
                this.chart.legend.position = "top";
                this.chart.legend.paddingBottom = 15;

                var categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "category";
                categoryAxis.renderer.labels.template.fontSize = 11;
                categoryAxis.renderer.labels.template.horizontalCenter = "middle";
                categoryAxis.renderer.labels.template.verticalCenter = "middle";
                categoryAxis.renderer.minGridDistance = 10;
                categoryAxis.renderer.grid.template.disabled = true;
                categoryAxis.renderer.grid.template.location = 0;
                categoryAxis.events.on("validated", (ev) => {
                    const axis = ev.target
                    const cellWidth = axis.pixelWidth / (axis.endIndex - axis.startIndex)
                    if (cellWidth <= 85) {
                        axis.renderer.labels.template.rotation = 300
                        categoryAxis.renderer.labels.template.verticalCenter = "bottom";
                    } else {
                        categoryAxis.renderer.labels.template.verticalCenter = "middle";
                        axis.renderer.labels.template.rotation = 0
                    }
                });

                var valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                valueAxis.min = 0;
                // valueAxis.max = 100;
                valueAxis.strictMinMax = true;
                valueAxis.calculateTotals = true;
                valueAxis.renderer.minWidth = 50;
                valueAxis.maxPrecision = 0;

                // tooltipHTML

                // SMILE
                var series1 = this.chart.series.push(new am4charts.ColumnSeries());
                series1.columns.template.width = am4core.percent(widthPercent);
                // series1.columns.template.tooltipText = this.tooltipFormat;
                // series1.columns.template.tooltipHTML = this.tooltipFormat;
                series1.name = this.translate(this.series.translate[0]);
                series1.dataFields.categoryX = "category";
                series1.dataFields.valueY = this.series.name[0];
                series1.dataFields.valueYShow = this.valueYShow;
                series1.dataItems.template.locations.categoryX = 0.5;
                series1.stacked = true;
                series1.tooltip.pointerOrientation = "vertical";
                series1.tooltip.getFillFromObject = false;
                series1.tooltip.background.fill = am4core.color("white");
                series1.stroke = am4core.color("rgba(0,0,0,0)");
                console.log(series1)

                series1.columns.template.events.on("hit", (ev) => {
                    this.dateSelecting(ev)
                }, this);

                //  NORMAL
                var series2 = this.chart.series.push(new am4charts.ColumnSeries());
                series2.columns.template.width = am4core.percent(widthPercent);
                // series2.columns.template.tooltipText = this.tooltipFormat;
                // series2.columns.template.tooltipHTML = this.tooltipFormat;
                series2.name = this.translate(this.series.translate[1]);
                series2.dataFields.categoryX = "category";
                series2.dataFields.valueY = this.series.name[1];
                series2.dataFields.valueYShow = this.valueYShow;
                series2.dataItems.template.locations.categoryX = 0.5;
                series2.stacked = true;
                series2.tooltip.pointerOrientation = "vertical";
                series2.tooltip.getFillFromObject = false;
                series2.tooltip.background.fill = am4core.color("white");
                series2.stroke = am4core.color("rgba(0,0,0,0)");

                series2.columns.template.events.on("hit", (ev) => {
                    this.dateSelecting(ev)
                }, this);


                //  SAD
                var series3 = this.chart.series.push(new am4charts.ColumnSeries());
                console.log(series3)
                series3.columns.template.width = am4core.percent(widthPercent);
                // series3.columns.template.tooltipHTML = this.tooltipFormat;
                series3.name = this.translate(this.series.translate[2]);
                series3.dataFields.categoryX = "category";
                series3.dataFields.valueY = this.series.name[2];
                series3.dataFields.valueYShow = this.valueYShow;
                series3.dataItems.template.locations.categoryX = 0.5;
                series3.stacked = true;
                series3.tooltip.pointerOrientation = "vertical";
                series3.tooltip.getFillFromObject = false;
                series3.tooltip.background.fill = am4core.color("white");
                series3.stroke = am4core.color("rgba(0,0,0,0)");

                series3.columns.template.events.on("hit", (ev) => {
                    this.dateSelecting(ev)
                }, this);

                var valueIndexAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
                this.valueIndexAxis = valueIndexAxis
                if (this.chart.yAxes.indexOf(valueAxis) != 0) {
                    valueAxis.syncWithAxis = this.chart.yAxes.getIndex(0);
                }
                this.refreshValueIndexAxis()
                valueIndexAxis.strictMinMax = true;
                // valueIndexAxis.renderer.line.strokeOpacity = 1;
                // valueIndexAxis.renderer.line.strokeWidth = 2;
                // valueIndexAxis.renderer.line.stroke = am4core.color(indexColor);
                // valueIndexAxis.renderer.labels.template.fill = am4core.color(indexColor);
                valueIndexAxis.renderer.opposite = true;
                valueIndexAxis.renderer.labels.template.showFirstLabel = false
                valueIndexAxis.renderer.baseGrid.disabled = true;
                valueIndexAxis.renderer.grid.template.disabled = false
                valueIndexAxis.renderer.grid.template.stroke = am4core.color(indexColor);
                valueIndexAxis.renderer.grid.template.strokeOpacity = 0.08;
                valueIndexAxis.renderer.grid.template.strokeWidth = 1;


                var indexSeries = this.chart.series.push(new am4charts.LineSeries());
                indexSeries.dataFields.valueY = "index";
                indexSeries.dataFields.categoryX = "category";
                indexSeries.yAxis = valueIndexAxis
                indexSeries.strokeWidth = 3;
                indexSeries.tensionX = 0.8;
                let indexBullet = indexSeries.bullets.push(new am4charts.CircleBullet());
                indexBullet.circle.stroke = am4core.color(indexColor);
                indexBullet.circle.radius = 4;
                indexBullet.tooltipText = "[bold]{valueY}[/]";

                this.showLoader = false

            },

            refreshValueIndexAxis() {
                let topDiff = 100 - this.amchartsData.maxIndex
                console.log(`zzz1 topDiff: ${topDiff}`)
                topDiff = topDiff > 20 ? 20 : topDiff
                let max = this.amchartsData.maxIndex + topDiff
                max = max > 90 ? 101 : max
                let min = this.amchartsData.minIndex - (topDiff > 20 ? topDiff : 20)
                console.log(`zzz2 topDiff: ${topDiff} max: ${max} min: ${min}`)
                min = min > 0 ? min : 0
                this.valueIndexAxis.min = min;
                this.valueIndexAxis.max = max;
            },
            changeColumnsOrder() {
                if (this.amchartsData.popoverType.indexOf('soso') != -1) {
                    this.series = {
                        name: ['ok', 'sad', 'happy', 'index'],
                        translate: ['own_SoSo', 'own_Sad', 'own_Happy', 'IndexAirvote'],
                        color: [
                            am4core.color(sosoColor),
                            am4core.color(sadColor),
                            am4core.color(happyColor),
                            am4core.color(indexColor)
                        ],
                    }
                } else if (this.amchartsData.popoverType.indexOf('sad') != -1) {
                    this.series = {
                        name: ['sad', 'ok', 'happy', 'index'],
                        translate: ['own_Sad', 'own_SoSo', 'own_Happy', 'IndexAirvote'],
                        color: [
                            am4core.color(sadColor),
                            am4core.color(sosoColor),
                            am4core.color(happyColor),
                            am4core.color(indexColor)
                        ]
                    }
                } else if (this.amchartsData.popoverType.indexOf('happy') != -1) {
                    this.series = {
                        name: ['happy', 'ok', 'sad', 'index'],
                        translate: ['own_Happy', 'own_SoSo', 'own_Sad', 'IndexAirvote'],
                        color: [
                            am4core.color(happyColor),
                            am4core.color(sosoColor),
                            am4core.color(sadColor),
                            am4core.color(indexColor)
                        ]
                    }
                }
                this.chart.colors.list = this.series.color
                for (let i = 0; i < this.chart.series.values.length; i++) {
                    console.log(this.chart.series.values[i])
                    this.chart.series.values[i].dataFields.valueY = this.series.name[i];
                    this.chart.series.values[i].name = this.translate(this.series.translate[i]);
                    this.chart.series.values[i].fill = this.series.color[i];
                    // this.chart.series.values[i].stroke = this.series.color[i];
                }

            },

            dateSelecting(ev){
                const index = ev.target.dataItem.index
                this.$emit('onHitDate', this.amchartsData.response.dates[index])
            },
            dataMapping(){
                let data = []
                console.log(this.amchartsData.response)
                this.amchartsData.response.dates.forEach((item, index) => {
                    data[index] = {
                        category: this.dateFormatter(item),
                        happy: this.amchartsData.response.happy[index],
                        ok: this.amchartsData.response.ok[index],
                        sad: this.amchartsData.response.sad[index],
                        index: this.amchartsData.response.indexes[index]
                    }
                })
                console.log(this.amchartsData.response.indexes)
                if (this.amchartsData.response.happy.length == 0 &&
                    this.amchartsData.response.sad.length == 0 &&
                    this.amchartsData.response.ok.length == 0) {
                    this.showStatus = true;
                } else {
                    this.showStatus = false;
                }
                return data
            },

            dateFormatter(value){
                console.log(`formatter:`, value)
                let format = "ddd, MMM DD"
                switch (this.amchartsData.currentDateType) {
                    case 'hour': {
                        format = "h a"
                        break
                    }
                    case 'month': {
                        if(this.amchartsData.response.dates.length > 12) {
                            format = "MMM, YYYY"
                        } else {
                            format = "MMM"
                        }
                        break
                    }
                }
                return moment(value).format(format)
            },

            chartDispose(){
                if (this.chart) {
                    this.chart.dispose();
                    this.chart = null
                }
            }
        },
        beforeDestroy() {
            this.chartDispose()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .chart {
        width: 100%;
        height: 300px;
    }

    .noDataInfo,
    .loader {
        position: absolute;
        background: rgba(255,255,255,.8);
        top: 35px;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        font-weight: 800;
        padding-bottom: 35px;
        z-index: 2;
    }
</style>